import { Injectable } from '@angular/core';
import { ColumnRepository } from '@database/workspace';
import { SortingColumn, SortingState } from '@domain/sorting';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ColumnModel, FileDataTypesMapSort, SortingTypeEnum } from '@shared';
import { firstValueFrom, map } from 'rxjs';
import { SortingComponent } from '@pages/smart-components';
import { SortingModel } from './sorting.model';

@Injectable()
export class SortingTriggerService {
	public constructor(
		private modalCtrl: ModalController,
		private columnRepository: ColumnRepository,
		private sortingState: SortingState,
		private translateService: TranslateService
	) {}

	public async showSortingModal(tableName: string): Promise<void> {
		const currentSortOption = await firstValueFrom(this.sortingState.getTableSortState(tableName));

		const sortingOptions = (
			await firstValueFrom(
				this.columnRepository
					.getColumns$(tableName)
					.pipe(
						map((columns: ColumnModel[]) =>
							columns
								.filter((column: ColumnModel) => column.display_order > 0)
								.sort((a, b) => a.display_order - b.display_order)
						)
					)
			)
		).map(
			(column: ColumnModel) =>
				new SortingColumn({
					displayName: column.column_label,
					name: column.column_name,
					isSelected: false,
					dataType: FileDataTypesMapSort[column.data_type]
				})
		);

		const sortingModel: SortingModel = {
			sortDirection: SortingTypeEnum.Ascending,
			columns: [
				new SortingColumn({
					displayName: this.translateService.instant('dropdown.lastCreated'),
					name: 'rxdbid',
					isSelected: false,
					dataType: FileDataTypesMapSort.NUMERIC
				}),
				...sortingOptions
			]
		};

		const index = sortingModel.columns.findIndex((el) => el.name === currentSortOption.selectedColumn.name);

		if (index >= 0) {
			sortingModel.sortDirection = currentSortOption.sortDirection;
			sortingModel.columns[index] = currentSortOption.selectedColumn;
		}

		const modal = await this.modalCtrl.create({
			component: SortingComponent,
			cssClass: 'custom-searcheable-select',
			backdropDismiss: true,
			initialBreakpoint: 0.85,
			componentProps: {
				sortingModel
			},
			showBackdrop: false
		});
		await modal.present();
		const { data } = await modal.onWillDismiss();

		if (data) {
			this.sortingState.setTableSortState(tableName, data);
		}
	}
}
